function MultiStepFormController(el) {
  this.$el = $(el);

  if (this.$el.length) {
    this.setupDefaults();

    if (!this.isExperienceEditor) {
      this.initDom();
      this.addListeners();
      this.buildProgressBar();
      this.showCurrentStep();
    }
  }
}



MultiStepFormController.prototype.setupDefaults = function() {
  this.isExperienceEditor = $('.partner-landing-msf__experience-editor').length;
  this.currentStep = 0;
  this.api = {
    getStates: '/api/MultiStepForm/GetStates',
    getPrograms: '/api/PartnerMultiStepForm/GetPartnerPrograms',
    getFieldOfStudy: '/api/PartnerMultiStepForm/GetCategories'
  };

  this.dom = {
    $progressBar: this.$el.find('.partner-landing-msf__progress-bar'),
    $form: this.$el.find('.partner-landing-msf__form'),
    $steps: this.$el.find('.partner-landing-msf__step'),
    $inputs: this.$el.find('.partner-landing-msf__input, .select-input'),
    $selectListboxes: this.$el.find('.select-listbox'),
    $dropdowns: this.$el.find('select.partner-landing-msf__input'),
    $countryDropdownContainer: this.$el.find('#partner-landing-msf__country-dropdown'),
    $countryDropdown: this.$el.find('#partner-landing-msf__country-dropdown input'),
    $stateDropdownContainer: this.$el.find('#partner-landing-msf__state-dropdown'),
    $stateDropdown: this.$el.find('#partner-landing-msf__state-dropdown input'),
    $regionInputContainer: this.$el.find('#partner-landing-msf__region-input'),
    $regionInput: this.$el.find('#partner-landing-msf__region-input input'),
    $nextStep: this.$el.find('.partner-landing-msf__next-btn'),
    $previousStep: this.$el.find('.partner-landing-msf__back-btn'),
    $submitBtn: this.$el.find('.partner-landing-msf__submit-btn'),
    $academicLevelDropdown: this.$el.find('#partner-landing-msf__academic-level-dropdown input'),
    $fieldOfStudyDropdown: this.$el.find('#partner-landing-msf__fieldOfStudy-dropdown input'),
    $fieldOfStudyDropdownWrapper: this.$el.find('#partner-landing-msf__fieldOfStudy-dropdown'),
    $pathTooltips: this.$el.find('.partner-landing-msf__choose-path-tooltip'),
    $pathChooserWrapper: this.$el.find('.partner-landing-msf__choose-path'),
    $pathChooser: this.$el.find('.partner-landing-msf__radio input'),
    $programDropdowns: this.$el.find('.partner-landing-msf__field-program-dropdown'),
    $globalError: this.$el.find('.partner-landing-msf__global-error'),
    $employerDropdown: this.$el.find('.select-wrapper #Notes')
  };

  this.dom.$stateDropdown.siblings('button').attr("disabled", true);
  this.dom.$programDropdowns.find('.select-button').attr("disabled", true);
  this.dom.$fieldOfStudyDropdownWrapper.addClass('disabled');

  this.errors = [];
};

MultiStepFormController.prototype.initDom = function() {
  var _this = this;

  if (this.dom.$stateDropdownContainer.length) {
    this.dom.$regionInputContainer.attr('aria-hidden', true).hide();
  }
  //Remove: HTML validation - Possible misuse of aria-label
  /*this.dom.$steps.each(function (i, element) {
      $(element).attr('aria-label', 'step ' + (i + 1) + ' of ' + _this.dom.$steps.length);
  });*/

  if (this.dom.$form[0]) {
    this.dom.$form[0].reset();
  }
};

MultiStepFormController.prototype.addListeners = function() {
  this.dom.$inputs.on('blur', this.onInputBlur.bind(this));
  this.dom.$selectListboxes.on('blur', this.onSelectListboxBlur.bind(this));
  this.dom.$inputs.on('change keyup', this.onInputChange.bind(this));
  this.dom.$regionInput.on('change keyup', this.onInputChange.bind(this));
  this.dom.$countryDropdown.on('change', this.onChangeCountry.bind(this));
  this.dom.$nextStep.on('touchstart click', this.onNextStepClick.bind(this));
  this.dom.$previousStep.on('touchstart click', this.onPreviousStepClick.bind(this));
  this.dom.$academicLevelDropdown.on('change', this.onChangeAcademicLevel.bind(this));
  this.dom.$fieldOfStudyDropdown.on('change', this.onChangeFieldOfStudy.bind(this));
  this.dom.$pathChooser.on('change', this.onPathChoose.bind(this));
  this.dom.$submitBtn.on('touchstart click', this.onSubmitForm.bind(this));
};

MultiStepFormController.prototype.buildProgressBar = function() {
  var html = '',
    className;

  this.dom.$steps.each(function(i, element) {
    className = (i === 0) ? ' partner-landing-msf__progress-step--current' : '';
    html += '<li class="partner-landing-msf__progress-step' + className + '"><span>' + (i + 1) + '</span></li>';
  });

  this.dom.$progressBar.html(html);
  this.dom.$progressBarSteps = this.$el.find('.partner-landing-msf__progress-step');
};

MultiStepFormController.prototype.showCurrentStep = function() {
  var _this = this;
  this.dom.$currentStep = this.dom.$steps.eq(this.currentStep);

  // Update progress bar
  for (var i = this.currentStep; i < this.dom.$progressBarSteps.length; i++) {
    this.dom.$progressBarSteps.eq(i).removeClass('partner-landing-msf__progress-step--completed');
  }

  this.dom.$progressBarSteps.removeClass('partner-landing-msf__progress-step--current');
  this.dom.$progressBarSteps.eq(this.currentStep).addClass('partner-landing-msf__progress-step--current');

  if (this.currentStep) {
    this.dom.$progressBarSteps.eq(this.currentStep - 1).addClass('partner-landing-msf__progress-step--completed');
  }

  this.dom.$form.addClass('partner-landing-msf__form--in-transition');

  setTimeout(function() {
    _this.dom.$form.removeClass('partner-landing-msf__form--in-transition');

    // Show current step
    _this.dom.$steps.removeClass('partner-landing-msf__step--current')
      .attr('aria-hidden', true);
    _this.dom.$currentStep.addClass('partner-landing-msf__step--current')
      .removeAttr('aria-hidden').focus();
  }, 500);
};

MultiStepFormController.prototype.onNextStepClick = function(e) {
  e.stopPropagation();
  e.preventDefault();

  if (!this.validateStep()) {
    return;
  }

  if (this.dom.$employerDropdown.length) { //has an employer dropdown with the id of Notes
    var turnkeyCompany = this.dom.$employerDropdown.val();
    var turnkeyOfferId = this.dom.$employerDropdown.parent('div').find('ul li.active').attr('data-other');
    var companyInput = this.dom.$form.find("#Company");
    var offerIdInput = this.dom.$form.find("#OfferId");
    if (companyInput.length) {
      companyInput.val(turnkeyCompany);
    }
    if (offerIdInput.length) {
      offerIdInput.val(turnkeyOfferId);
    }
  }

  this.currentStep++;
  this.showCurrentStep();
};

MultiStepFormController.prototype.onPreviousStepClick = function(e) {
  e.stopPropagation();
  e.preventDefault();

  this.currentStep--;
  this.showCurrentStep();
};

MultiStepFormController.prototype.onChangeCountry = function(e) {
  var _this = this,
    country = this.dom.$countryDropdown.val(),
    $stateDropdown = this.dom.$stateDropdown.siblings('ul'),
    $stateButton = this.dom.$stateDropdown.siblings('button'),
    $regionInput = this.dom.$regionInput;

  this.dom.$countryDropdown.focus();
  this.clearValidation($stateDropdown);
  $stateButton.attr("disabled", true);
  this.dom.$stateDropdownContainer.addClass("disabled").show();

  $regionInput.val("");
  this.clearValidation($regionInput);
  this.dom.$regionInputContainer.attr("aria-hidden", true).hide();

  if (!country) {
    return;
  }

  $.post(
    this.api.getStates,
    { countryId: country }
  )
    .done(function(data) {
      if (data.length) {
        if ($stateDropdown.children('li').length === 0) {
          var options = "";
          data.forEach(function (state) {
              options += "<li role='option' data-value='" + state.Value + "' id='" + state.Value + "-State'>" + state.Text + "</li>";
          });
          $stateDropdown.append(options);
        }
        $stateButton.removeAttr("disabled");
        _this.dom.$stateDropdownContainer.removeClass("disabled");
      } else {
        _this.dom.$regionInputContainer.removeAttr("aria-hidden").show();
        $stateButton.attr("disabled", true);
        _this.dom.$stateDropdownContainer.hide();
      }
    });
};

MultiStepFormController.prototype.onInputBlur = function(e) {
  e.stopPropagation();
  var $input = $(e.target);
  $input.addClass('partner-landing-msf__input--blured');
  $input.val($input.val().trim());

  if ($input.val()) {
    $input.addClass('partner-landing-msf__input--filled');
  } else {
    $input.removeClass('partner-landing-msf__input--filled');
  }

  this.validate($input);
};

MultiStepFormController.prototype.onSelectListboxBlur = function(e) {
  e.stopPropagation();
  var listbox = $(e.target);
  var parent = listbox.parent(),
    button = listbox.siblings('button'),
    input = listbox.siblings('input');

  var value = input.val(),
    error;
  this.clearValidation(input);

  if (input.attr('required') && !this.validateRequired(input, value)) {
    error = input.data('required-msg');
  }

  if (error) {
    this.errors.push("- " + error + "\n");
    button.attr("aria-invalid", true);
    parent.addClass('partner-landing-msf__field--error')
      .find('.select-error-label').text(error);
  }
};

MultiStepFormController.prototype.onInputChange = function(e) {
  var $input = $(e.target);

  if ($input.hasClass('partner-landing-msf__input--blured') ||
    $input.attr('id') === 'Region' ||
    $input.hasClass('select-input')
  ) {
    this.validate($input);
  }
};

MultiStepFormController.prototype.updateDropdownOptions = function($dropdown, optionsArray) {
  var optionsHTML = '';
  if (optionsArray) {
    optionsArray.forEach(function(element, index) {
      if (index === 0) {
        optionsHTML += "<li role='option' class='hover' data-value='" + element.Value + "' id='" + element.Value + "-Program'>" + element.Text + "</option>";
      } else {
        optionsHTML += "<li role='option' data-value='" + element.Value + "' id='" + element.Value + "-Program'>" + element.Text + "</option>";
      }
    });
  }
  $dropdown.empty();
  $dropdown.append(optionsHTML);
};

MultiStepFormController.prototype.onChangeAcademicLevel = function(e) {
  this.academicLevel = $(e.target).val();
  ResetFieldOfStudy(this, this.dom.$fieldOfStudyDropdownWrapper);
  this.updateFieldOfStudy();
  this.dom.$fieldOfStudyDropdownWrapper.removeClass("disabled");
  this.updatePrograms();
};

MultiStepFormController.prototype.onChangeFieldOfStudy = function(e) {

  this.fieldOfStudy = $(e.target).val();
  this.updatePrograms();
};

MultiStepFormController.prototype.resetProgramDropdowns = function() {
  ResetPathProgramDropdowns(this, this.dom.$programDropdowns);
  this.dom.$pathChooserWrapper.attr('aria-invalid', false);
  this.dom.$pathChooserWrapper.next().removeClass('partner-landing-msf__field--error');
  this.dom.$pathChooser.prop('disabled', true).prop('checked', false);
  this.dom.$pathTooltips.removeAttr('style');
};

MultiStepFormController.prototype.updatePrograms = function() {
  var _this = this;
  if (this.academicLevel ) {
    var formId = $('#formId').val();
    this.resetProgramDropdowns();
    $.post(
      this.api.getPrograms,
      { academicLevel: this.academicLevel, category: this.fieldOfStudy, formId: formId }
    )
      .done(function(data) {
        var hasData = [], radio = null;

        data.forEach(function(item, index) {
          radio = $("[data-controls='" + item.LocationId + "']");

          if (item.Programs.length) {
            radio.prop('disabled', false);
            hasData[index] = {
              locationId: item.LocationId,
              count: item.Programs.length
            };
          }

          _this.updateDropdownOptions($('#' + item.LocationId).find('ul'), item.Programs);
        });

        if (hasData[0] && hasData[1]) {
          hasData.forEach(function(item) {
            $("[data-controls='" + item.locationId + "']").prop('checked', false);
          });
          radio = $("[data-controls='" + hasData[0].locationId + "']");
          radio.trigger('click').trigger('change');
          radio.parents().eq(1).trigger('click');
        } else if (!hasData[0] && hasData[1]) {
          radio.trigger('click').trigger('change');
          radio.parents().eq(1).trigger('click');
        } else if (hasData[0] && !hasData[1]) {
          radio = $("[data-controls='" + hasData[0].locationId + "']");
          radio.trigger('click').trigger('change');
          radio.parents().eq(1).trigger('click');
        } else if (!hasData[0] && !hasData[1]) {
          $(".partner-landing-msf__field-program-dropdown").first().removeClass('hidden').addClass('disabled');
        }

        hasData.forEach(function(item, index) {
          if (item.count === 1) {
            $('#' + item.locationId).find('ul')
              .children().first().click();
          }
        });
      });
  } else {
    this.dom.$pathChooser.prop('disabled', true);
  }
};

MultiStepFormController.prototype.updateFieldOfStudy = function() {
  var _this = this;
  if (this.academicLevel) {
    var formId = $('#formId').val();
    var dropdownUL = this.$el.find('#partner-landing-msf__fieldOfStudy-dropdown ul');

    $.post(
      _this.api.getFieldOfStudy,
      { programGroupID: this.academicLevel, formId: formId }
    )
      .done(function(data) {
        _this.updateDropdownOptions(dropdownUL, data);
      });
  }
};

function ResetFieldOfStudy(thisVariable, dropdown) {
  thisVariable.fieldOfStudy = undefined; //reset fieldofstudy variable
  var currentDropdown = dropdown,
    buttons = currentDropdown.find('.select-button'),
    label = currentDropdown.find('.select-label'),
    input = currentDropdown.find('.select-input');

  thisVariable.updateDropdownOptions(dropdown.find('ul'), null);
  currentDropdown.addClass('disabled').removeClass('partner-landing-msf__field--error');
  buttons.text(function() { return $(this).attr('aria-label'); }).removeAttr('aria-invalid').removeAttr('aria-activedescendant');
  input.val(null);
  label.empty();
}


function ResetPathProgramDropdowns(thisVariable, programDropDowns) {
  var dropdowns = programDropDowns,
    buttons = programDropDowns.find('.select-button'),
    labels = programDropDowns.find('.select-label'),
    inputs = programDropDowns.find('.select-input');
  dropdowns.addClass('hidden').removeClass('partner-landing-msf__field--error');
  buttons.text(function() { return $(this).attr('aria-label'); })
    .removeAttr('aria-invalid').removeAttr('aria-activedescendant');
  inputs.val(null);
  labels.empty();
}

MultiStepFormController.prototype.onPathChoose = function(e) {
  this.dom.$pathChooserWrapper.attr('aria-invalid', false);
  this.dom.$pathChooserWrapper.next().removeClass('partner-landing-msf__field--error')
    .find('.select-error-label').empty();

  var radio = $(e.target);
  var target = radio.data('controls');

  if ($(window).width() > 768) {
    this.dom.$pathTooltips.removeAttr('style');
    radio.parent().next('.' + this.dom.$pathTooltips.attr('class')).css('display', 'inline');
  }

  ResetPathProgramDropdowns(this, this.dom.$programDropdowns);

  $('#' + target).removeClass('disabled').removeClass('hidden');
  $('#' + target).find('.select-button').attr("disabled", false);
};

MultiStepFormController.prototype.onSubmitForm = function(e) {
  e.stopPropagation();
  e.preventDefault();

  this.dom.$globalError.html("");


  if (!this.validateStep()) {
    return;
  }

  var _this = this;

  var formData = {};
  this.dom.$form.find('input').each(function() {
    var input = $(this);
    if (input.val()) {
      if (input.attr("type") === 'checkbox') {
        formData[input.attr("name")] = input.is(':checked') ? "true" : "false";
      } else {
        formData[input.attr("name")] = input.val();
      }
    }
  });
  formData["SelectedLocation"] = $('[name="SelectedLocation"]:checked').val();

  $.post(
    this.dom.$form.attr('action'),
    formData
  ).done(function(data) {
    if (data.Success) {
      window.location.href = data.RedirectUrl;
    } else {
      _this.applyServerValidation(data.Errors);
    }
  });
};


MultiStepFormController.prototype.validateStep = function() {
  var _this = this,
    valid = true,
    $currentStepInputs = this.dom.$currentStep.find(
      ".partner-landing-msf__field:visible input, .partner-landing-msf__field-program-dropdown:not(.hidden) input"
    );

  this.errors = [];

  $currentStepInputs.each(function(i, input) {
    var el = $(input);

    if (!_this.isValid(el)) {
      valid = false;
      _this.validate(el);
    }
  });

  this.errors = this.errors.filter(function(item, index) {
    return _this.errors.indexOf(item) === index;
  });

  if (!valid) {
    alert(this.errors.join("").replace(",", ""));
    return false;
  }

  return true;
};

MultiStepFormController.prototype.validate = function($input) {
  var value = $input.val(),
    error = null,
    parent = $input.parents(".partner-landing-msf__field:visible, .partner-landing-msf__field-program-dropdown:not(.disabled)");

  this.clearValidation($input);

  if ($input.attr('required') && !this.validateRequired($input, value)) {
    error = $input.data('requiredMsg');
  } else if ($input.attr('type') === 'email' && !this.validateEmail(value)) {
    error = $input.data('emailMsg');
  } else if ($input.data('phone') && !this.validatePhone(value)) {
    error = $input.data('phoneMsg');
  }

  if (error) {
    this.errors.push("- " + error + "\n");
    $input.attr('aria-invalid', true);
    parent.addClass('partner-landing-msf__field--error');

    if ($input.hasClass("select-input")) {
      parent.find(".select-error-label").text(error)
        .find('.select-button').attr('aria-invalid', true);
    } else {
      parent.append(' <label class="partner-landing-msf__error-label">' + error + '</label>');
    }
  }
};

MultiStepFormController.prototype.isValid = function($input) {
  var value = $input.val();
  var $parent = $input.parents('.partner-landing-msf__field');

  if (($input.attr('required') && !this.validateRequired($input, value)) ||
    ($input.attr('type') === 'email' && !this.validateEmail(value)) ||
    ($input.data('phone') && !this.validatePhone(value)) ||
    ($parent.hasClass('partner-landing-msf__field--error'))) {
    return false;
  }

  return true;
};

MultiStepFormController.prototype.clearValidation = function($input) {
  $input.parents('.partner-landing-msf__field')
    .removeClass('partner-landing-msf__field--error')
    .find('.partner-landing-msf__error-label').remove();

  $input.siblings().removeAttr("aria-invalid");

  $input.attr('aria-invalid', false);
};

MultiStepFormController.prototype.validateRequired = function($input, value) {
  if ($input.is(':checkbox')) {
    return $input.is(':checked');
  }
  if ($input.is(':radio')) {
    if ($input.attr('name')) {
      return $('[name=' + $input.attr('name') + ']:checked').length;
    } else {
      return $input.is(':checked');
    }
  }
  return value !== undefined && value !== null && value.length > 0;
};

MultiStepFormController.prototype.validateEmail = function(value) {
  return /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value);
};

MultiStepFormController.prototype.validatePhone = function(value) {
  return value.length === 10 && /^\d+$/.test(value);
};

MultiStepFormController.prototype.applyServerValidation = function(errorsList) {
  //Iterate ErrorListObject and if property is not null, 
  //apply validation to the listed fields.
  var stepIndexToShow = -1;
  var _this = this;

  if (!errorsList) return;

  console.log(errorsList)

  if (errorsList.Global) {
    this.dom.$globalError.html(errorsList.Global);
  } else {
    Object.getOwnPropertyNames(errorsList).forEach(function(step) {
      var stepErrorList = errorsList[step];

      if (stepErrorList) {
        var currentStepIndex = parseInt(step.split('Step')[1]) - 1;

        //Set step to return to after processing errors
        if (stepIndexToShow === -1) {
          stepIndexToShow = currentStepIndex;
        }

        //Iterate errors for current step and update form accordingly
        stepErrorList.forEach(function(errorObj) {
          var fieldName = errorObj.FieldName;
          var $input = $('[name=' + fieldName + ']');
          var error = $input.attr(errorObj.ErrorMessage);
          var $parent = $input.parents('.multi-step-form__field');

          _this.clearValidation($input);

          if (error) {
            $input.attr('aria-invalid', true);
            $parent.addClass('multi-step-form__field--error')
              .append(' <label class="multi-step-form__error-label">' + error + '</label>');
          }
        });
      }
    });

    this.currentStep = stepIndexToShow;
    this.showCurrentStep();
  }
};

(function($) {
  $('.partner-landing-msf').each(function(i, el) {
    new MultiStepFormController(el);
  });
})(jQuery);